/* tslint:disable */
/* eslint-disable */
export enum WorkProspectStatusEnum {
  Open = 'open',
  Converted = 'converted',
  Discarded = 'discarded'
}
